// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"115cf123","657":"9d5e7c5e"}[chunkId] + ".chunk.css";
};